import { useEffect, useState, MouseEventHandler } from "react";
import { useNavigate } from "react-router-dom";
import ProductModel from "../../../product/models/product_model";
import profileImage from "../../../../assets/images/profile.png";

import menuAddress from "../../../../assets/images/menu_address.svg";
import menuSecurity from "../../../../assets/images/menu_security.svg";
import menuContact from "../../../../assets/images/menu_contact.svg";
import menuPrivacyPolicy from "../../../../assets/images/menu_privacy_policy.svg";
import menuLogout from "../../../../assets/images/menu_logout.svg";
import ProfileDialog from "./dialogs/profile_dialog";
import EditPasswordDialog from "./dialogs/edit_password_dialog";
import LogoutDialog from "./dialogs/logout_dialog";
import EditFormDialog from "./dialogs/edit_form_dialog";
import TextInput from "../../../shared/components/text_input";
import { spawn } from "child_process";
import routes from "../../../../routes";
import authFacade from "../../../authentication/facades/auth_facade";
import ProtectedContent from "../../../shared/components/unauthenticated";
import profileFacade from "../../facades/profile_facade";
import settingFacade from "../../facades/setting_facade";
import mamaPointFacade from "../../facades/mama_point_facade";

function SettingPage() {
  const navigate = useNavigate();
  const [openProfileDetail, setOpenProfileDetail] = useState(false);
  const [openEditPassword, setOpenEditPassword] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);

  const { logout } = authFacade();
  const { user, fetchUser } = profileFacade();
  const { setting, fetchSetting } = settingFacade();
  const { mamaPoint, fetchMamaPoint } = mamaPointFacade();

  const numberWithCommas = (value: number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      currencyDisplay: "symbol", // Use 'code' for currency code (e.g., IDR)
    }).format(value);
  };

  useEffect(() => {
    fetchUser();
    fetchMamaPoint();
    fetchSetting();
  }, []);

  return (
    <div className="page">
      <div className="header">
        <p className="title">Pengaturan</p>
      </div>
      <div className="page-content">
        <div className="profile-section">
          <figure>
            <img src={user.image_url_text ?? profileImage} alt="" />
          </figure>
          <div className="column expanded">
            <h4>{user.name ?? ""}</h4>
            <p>
              <span className="phone">
                {`${user.phone_country_code ?? ""}${user.phone ?? ""}`}
              </span>
              <span className="email">{user.email ?? ""}</span>
            </p>
          </div>
          <svg
            onClick={() => setOpenProfileDetail(true)}
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="1" y="1" width="23" height="23" rx="11.5" fill="#F5F1F2" />
            <path
              d="M13.5369 8.44273C13.9094 8.03904 14.0957 7.8372 14.2937 7.71946C14.7714 7.43538 15.3595 7.42655 15.8452 7.69616C16.0464 7.8079 16.2385 8.00406 16.6225 8.39638C17.0066 8.7887 17.1986 8.98486 17.308 9.19046C17.5719 9.68656 17.5633 10.2874 17.2852 10.7754C17.1699 10.9776 16.9723 11.1679 16.5772 11.5485L11.8753 16.0771C11.1264 16.7984 10.752 17.1591 10.284 17.3419C9.81606 17.5246 9.3016 17.5112 8.27268 17.4843L8.13269 17.4806C7.81945 17.4724 7.66283 17.4683 7.57179 17.365C7.48075 17.2617 7.49318 17.1022 7.51804 16.7831L7.53154 16.6098C7.6015 15.7118 7.63649 15.2627 7.81185 14.8591C7.98722 14.4555 8.28972 14.1277 8.89471 13.4723L13.5369 8.44273Z"
              stroke="#EEA9A9"
              strokeWidth="0.9"
              strokeLinejoin="round"
            />
            <path
              d="M13 8.5L16.5 12"
              stroke="#EEA9A9"
              strokeWidth="0.9"
              strokeLinejoin="round"
            />
            <path
              d="M13.5 17.5L17.5 17.5"
              stroke="#EEA9A9"
              strokeWidth="0.9"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              x="1"
              y="1"
              width="23"
              height="23"
              rx="11.5"
              stroke="#FFC1C1"
              strokeWidth="0.5"
            />
          </svg>
        </div>
        <div className="height-18"></div>
        <div className="profile-card">
          <div className="expanded">
            <h5>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g clipPath="url(#clip0_293_6327)">
                  <path
                    d="M5.5 4.5H7.5C7.63261 4.5 7.75979 4.44732 7.85356 4.35355C7.94732 4.25979 8 4.13261 8 4C8 3.86739 7.94732 3.74022 7.85356 3.64645C7.75979 3.55268 7.63261 3.5 7.5 3.5H6.5V3C6.5 2.86739 6.44732 2.74022 6.35356 2.64645C6.25979 2.55268 6.13261 2.5 6 2.5C5.86739 2.5 5.74022 2.55268 5.64645 2.64645C5.55268 2.74022 5.5 2.86739 5.5 3V3.5C5.10218 3.5 4.72065 3.65804 4.43934 3.93934C4.15804 4.22064 4 4.60218 4 5C4 5.39783 4.15804 5.77936 4.43934 6.06066C4.72065 6.34197 5.10218 6.5 5.5 6.5H6.5C6.63261 6.5 6.75979 6.55268 6.85356 6.64645C6.94732 6.74022 7 6.86739 7 7C7 7.13261 6.94732 7.25979 6.85356 7.35355C6.75979 7.44732 6.63261 7.5 6.5 7.5H4.5C4.36739 7.5 4.24022 7.55268 4.14645 7.64645C4.05268 7.74022 4 7.86739 4 8C4 8.13261 4.05268 8.25979 4.14645 8.35355C4.24022 8.44732 4.36739 8.5 4.5 8.5H5.5V9C5.5 9.13261 5.55268 9.25979 5.64645 9.35355C5.74022 9.44732 5.86739 9.5 6 9.5C6.13261 9.5 6.25979 9.44732 6.35356 9.35355C6.44732 9.25979 6.5 9.13261 6.5 9V8.5C6.89783 8.5 7.27936 8.34197 7.56066 8.06066C7.84197 7.77936 8 7.39783 8 7C8 6.60218 7.84197 6.22064 7.56066 5.93934C7.27936 5.65804 6.89783 5.5 6.5 5.5H5.5C5.36739 5.5 5.24022 5.44732 5.14645 5.35355C5.05268 5.25979 5 5.13261 5 5C5 4.86739 5.05268 4.74022 5.14645 4.64645C5.24022 4.55268 5.36739 4.5 5.5 4.5ZM6 0.5C4.91221 0.5 3.84884 0.822569 2.94437 1.42692C2.0399 2.03127 1.33495 2.89025 0.918665 3.89524C0.502383 4.90024 0.393465 6.0061 0.605683 7.073C0.817902 8.13989 1.34173 9.1199 2.11092 9.88909C2.8801 10.6583 3.86011 11.1821 4.92701 11.3943C5.9939 11.6065 7.09977 11.4976 8.10476 11.0813C9.10976 10.6651 9.96874 9.96011 10.5731 9.05564C11.1774 8.15117 11.5 7.0878 11.5 6C11.5 4.54131 10.9205 3.14236 9.88909 2.11091C8.85764 1.07946 7.45869 0.5 6 0.5ZM6 10.5C5.10999 10.5 4.23996 10.2361 3.49994 9.74161C2.75992 9.24715 2.18314 8.54434 1.84254 7.72208C1.50195 6.89981 1.41284 5.99501 1.58647 5.12209C1.7601 4.24918 2.18869 3.44736 2.81802 2.81802C3.44736 2.18868 4.24918 1.7601 5.1221 1.58647C5.99501 1.41283 6.89981 1.50195 7.72208 1.84254C8.54435 2.18314 9.24715 2.75991 9.74162 3.49993C10.2361 4.23996 10.5 5.10998 10.5 6C10.5 7.19347 10.0259 8.33807 9.18198 9.18198C8.33807 10.0259 7.19348 10.5 6 10.5Z"
                    fill="#191919"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_293_6327">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Mama Poin{" "}
              <span onClick={() => navigate(routes.mamaPoint)}>Informasi</span>
            </h5>
            <p>
              {numberWithCommas(
                (mamaPoint.data?.length ?? 0) == 0
                  ? 0
                  : mamaPoint.data![0].point_final ?? 0
              )}
            </p>
          </div>
          <div className="divider"></div>
          <div className="expanded">
            <h5>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <path
                  d="M10.5 2H9V1.5C9 1.36739 8.94732 1.24021 8.85355 1.14645C8.75979 1.05268 8.63261 1 8.5 1H3.5C3.36739 1 3.24021 1.05268 3.14645 1.14645C3.05268 1.24021 3 1.36739 3 1.5V2H1.5C1.36739 2 1.24021 2.05268 1.14645 2.14645C1.05268 2.24021 1 2.36739 1 2.5V4C1 4.53043 1.21071 5.03914 1.58579 5.41421C1.96086 5.78929 2.46957 6 3 6H3.77C4.22227 6.50457 4.83203 6.84118 5.5 6.955V8H5C4.60218 8 4.22064 8.15804 3.93934 8.43934C3.65804 8.72064 3.5 9.10218 3.5 9.5V10.5C3.5 10.6326 3.55268 10.7598 3.64645 10.8536C3.74021 10.9473 3.86739 11 4 11H8C8.13261 11 8.25979 10.9473 8.35355 10.8536C8.44732 10.7598 8.5 10.6326 8.5 10.5V9.5C8.5 9.10218 8.34196 8.72064 8.06066 8.43934C7.77936 8.15804 7.39782 8 7 8H6.5V6.955C7.16797 6.84118 7.77773 6.50457 8.23 6H9C9.53043 6 10.0391 5.78929 10.4142 5.41421C10.7893 5.03914 11 4.53043 11 4V2.5C11 2.36739 10.9473 2.24021 10.8536 2.14645C10.7598 2.05268 10.6326 2 10.5 2ZM3 5C2.73478 5 2.48043 4.89464 2.29289 4.70711C2.10536 4.51957 2 4.26522 2 4V3H3V4C3.0011 4.34085 3.06028 4.67903 3.175 5H3ZM7 9C7.13261 9 7.25979 9.05268 7.35355 9.14645C7.44732 9.24021 7.5 9.36739 7.5 9.5V10H4.5V9.5C4.5 9.36739 4.55268 9.24021 4.64645 9.14645C4.74021 9.05268 4.86739 9 5 9H7ZM8 4C8 4.53043 7.78929 5.03914 7.41421 5.41421C7.03914 5.78929 6.53043 6 6 6C5.46957 6 4.96086 5.78929 4.58579 5.41421C4.21071 5.03914 4 4.53043 4 4V2H8V4ZM10 4C10 4.26522 9.89464 4.51957 9.70711 4.70711C9.51957 4.89464 9.26522 5 9 5H8.825C8.93972 4.67903 8.9989 4.34085 9 4V3H10V4Z"
                  fill="#191919"
                />
              </svg>
              Level{" "}
              <span onClick={() => navigate(routes.membership)}>Informasi</span>
            </h5>
            <p>{(user.membership_level ?? "").split(" ")[0]}</p>
          </div>
        </div>
        <div className="height-18"></div>
        <div className="menu-label">Pengaturan Akun</div>
        <div className="menus">
          <ProfileMenu
            icon={menuAddress}
            label="Alamat"
            text="Kelola daftar alamat anda"
            onClick={() => navigate(routes.address)}
          />
          <div className="divider"></div>
          <ProfileMenu
            icon={menuSecurity}
            label="Keamanan Akun"
            text="Ganti kata sandi akun"
            onClick={() => setOpenEditPassword(true)}
          />
          <div className="divider"></div>
          <ProfileMenu
            onClick={() => window.open("https://wa.me/628888695757", "_blank")}
            icon={menuContact}
            label="Hubungi Kami"
            text="Kami akan dengan senang hati membantu anda"
          />
          <div className="divider"></div>
          <ProfileMenu
            icon={menuPrivacyPolicy}
            label="Kebijakan Privasi"
            text="Baca dan pelajari kebijakan privasi"
            onClick={() =>
              navigate(routes.privacyPolicy, { state: setting.privacy_policy })
            }
          />
          <div className="divider"></div>
          <ProfileMenu
            icon={menuPrivacyPolicy}
            label="Syarat dan Ketentuan"
            text="Baca dan pelajari syarat ketentuan pengguna"
            onClick={() =>
              navigate(routes.termsCondition, {
                state: setting.terms_conditions,
              })
            }
          />
          <div className="divider"></div>
          {/* <ProfileMenu
                        icon={menuSecurity}
                        label="Rate & Review Apps"
                        text="Versi 1.2.1"
                    /> */}
          {/* <ProfileMenu
            icon={menuSecurity}
            label="Versi Aplikasi"
            text="Versi 1.2.1"
          /> */}
          {/* <div className="divider"></div> */}
          <ProfileMenu
            icon={menuLogout}
            label="Keluar Akun"
            text="Keluar dari akun sekarang"
            onClick={() => setOpenLogout(true)}
          />
        </div>
      </div>
      <ProfileDialog
        onMenuClick={(value) => {}}
        open={openProfileDetail}
        onClose={() => setOpenProfileDetail(false)}
      />
      <EditPasswordDialog
        open={openEditPassword}
        onClose={() => setOpenEditPassword(false)}
      />
      <LogoutDialog
        open={openLogout}
        onClose={() => setOpenLogout(false)}
        onSubmit={() => {
          logout();
          setOpenLogout(false);
          navigate(routes.home);
        }}
      />
    </div>
  );
}

interface ProfileMenuProp {
  label: string;
  text: string;
  icon: string;
  onClick?: MouseEventHandler;
}
function ProfileMenu(props: ProfileMenuProp) {
  return (
    <div className="profile-menu" onClick={props.onClick}>
      <img src={props.icon} />
      <div className="expanded">
        <div className="label">{props.label}</div>
        <div className="text">{props.text}</div>
      </div>
    </div>
  );
}

export default SettingPage;
